import Vue from "vue"
import VueI18n from "vue-i18n"
import getLocale from "@/utils/locale"
import FeaturedBook from "@/features/featured-book/components/featured-book"
import platform from "@/modules/visitor-platform"
import globals from "@/utils/globals"
import store from "@/store/"

Vue.use(VueI18n)

document.querySelectorAll(".js-featured-book").forEach((el) => {
  const bookSlug = el.dataset.bookSlug
  const book = globals.featuredBooks[bookSlug]

  if (book) {
    new Vue({
      name: "FeaturedBook",
      el,
      store,
      i18n: new VueI18n({ locale: getLocale() }),
      components: { FeaturedBook },
      data() {
        return {
          book: book,
          platform: platform.platform
        }
      },
      template: `
        <FeaturedBook
          :book="book"
          :platform="platform" />
      `
    })
  }
})
